module.exports = __webpack_public_path__ + "static/img/juice_2.3397d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/juice_2.png
// module id = 1nvm
// module chunks = 0